export default "__VITE_ASSET__Dh00ex1u__"